import Clipboard from "clipboard";

// 默认接受十位的,然后补全十三位
export function dateFormat(timestamp) {
  if (String(timestamp).length == 10) {
    timestamp = timestamp * 1000;
  }
  const date = new Date(timestamp);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  let time = date.getTime();
  month = month >= 10 ? month : "0" + month;
  day = day >= 10 ? day : "0" + day;
  hours = hours >= 10 ? hours : "0" + hours;
  minutes = minutes >= 10 ? minutes : "0" + minutes;
  seconds = seconds >= 10 ? seconds : "0" + seconds;
  time = time >= 10 ? time : "0" + time;
  const obj = {
    year: year,
    month: month,
    day: day,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    time: time,
    ymd: year + "-" + month + "-" + day,
    ymdhm: year + "-" + month + "-" + day + " " + hours + ":" + minutes,
    ymdhms: year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds,
    ms: minutes + ":" + seconds,
    hs: hours + ":" + minutes
  };
  return obj;
}

export function getStyleObj(ele) {
  let styleObj = {};
  let style = ele.getAttribute("style") ? ele.getAttribute("style").split(";") : [];
  style.forEach(item => {
    item = item.replace(/\s/gim, "");
    let arr = item.split(":");
    styleObj[arr[0]] = arr[1];
  });
  return styleObj;
}

/**
 * 函数防抖
 */
export function debounce(fn, delay = 200) {
  // 记录上一次的延时器
  let timer = null;
  return function() {
    let args = arguments;
    let that = this;
    // 清除上一次延时器
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}

/**
 * 立刻执行防抖
 * @param {function} func           防抖函数
 * @param {number} wait             防抖时间间隔
 * @return {function}               返回客户调用函数
 */
function immediateDebounce(func, wait = 50) {
  let timer;
  let isRepeat = false; // 是否重复点击
  const later = () =>
    setTimeout(() => {
      isRepeat = false; // 延时wait后 isRepeat=false，timer=null，便可以调用函数
      timer = null;
    }, wait);

  return function(...params) {
    if (!timer && !isRepeat) {
      // isRepeat=false，timer=null，便可以调用函数
      func.apply(this, params);
    } else {
      isRepeat = true;
    }
    timer && clearTimeout(timer);
    timer = later();
  };
}

/**
 =* 可配置防抖函数
 * @param  {function} func        回调函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为ture时，是否立即调用函数
 * @return {function}             返回客户调用函数
 */
export function newDebounce(func, wait = 50, immediate = true) {
  return immediate ? immediateDebounce(func, wait) : debounce(func, wait);
}

/**
 * 函数节流
 */
export function throttle(fn, delay) {
  let timer;
  return function() {
    if (!timer) {
      fn.apply(this, arguments);
      timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
      }, delay);
    }
  };
}
/**
 * 节流
 * @param {*} func
 * @param {*} delay
 * @param {*} immediate
 * @returns
 */

export function immediateThrottle(func, delay, immediate = false) {
  let timer = null;
  let isFirst = immediate;
  return function() {
    const context = this;
    const args = arguments;
    if (isFirst) {
      func.apply(context, args);
      isFirst = false;
      return;
    }
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
}

// base64转file;
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}

// 获取时长
export function calcDuration(duration) {
  if (!duration) return 0;
  let hour = Math.floor(duration / 3600);
  let minute = Math.floor((duration % 3600) / 60);
  let second = Math.floor(duration % 60);
  return `${hour > 0 ? `${hour < 10 ? `0${hour}` : hour}` : ""}${minute < 10 ? `0${minute}` : minute}:${
    second < 10 ? `0${second}` : second
  }`;
}

// 获取是否为主站
export function checkIsWww(host) {
  return [
    "www-s.gamekee.com",
    "www.gamekee.com",
    "www.stage.gamekee.com",
    "www.pre.gamekee.com",
    "www.local.gamekee.com"
  ].includes(host);
}

// 检查是否有wiki
export function checkIsHasWiki(alias, gameId) {
  if (!alias || alias == gameId) {
    return false;
  }
  return true;
}

/**
 * 获取跳转wiki地址
 * @param {*} item
 * @returns
 */
export function getJumpWikiUrl(alias, gameId, isHasWiki) {
  // 没有wiki的，跳游戏页
  if (!isHasWiki) {
    return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/game`;
  }
  return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/`;
}

/**
 * 获取跳转wiki文章详情地址
 * @param {*} alias
 * @param {*} gameId
 * @param {*} detailId
 * @returns
 */
export function getJumpWikiDetailUrl(alias, gameId, detailId, isPath = false, isNewTj) {
  if (isNewTj === "zbtj") {
    if (isPath) {
      return `/${alias}/zbtj/${detailId}`;
    }
    return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/zbtj/${detailId}`;
  }
  if (isNewTj) {
    if (isPath) {
      return `/${alias}/tj/${detailId}.html`;
    }
    return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/tj/${detailId}.html`;
  }
  // 主站点
  if (alias === "www") {
    if (isPath) {
      return `/${detailId}.html`;
    }
    return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${detailId}.html`;
  }
  if (isPath) {
    return `/${alias}/${detailId}.html`;
  }
  return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/${detailId}.html`;
}

/**
 * 获取跳转wiki社区地址的
 * @param {*} alias
 * @param {*} gameId
 * @returns
 */
export function getJumpWikiListUrl(alias, gameId, isHasWiki) {
  return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/list`;
}

/**
 * 获取跳转wiki游戏页地址
 * @param {*} alias
 * @param {*} gameId
 * @returns
 */
export function getJumpWikiGameUrl(alias, gameId, isHasWiki) {
  return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/game`;
}

/**
 * 获取跳转wiki日历页
 * @param {*} alias
 * @param {*} gameId
 * @returns
 */
export function getJumpWikiDateUrl(alias, gameId) {
  return `//www.${process.env.VUE_APP_WIKI_DOMAIN}/${alias}/date`;
}

// 获路由地址
export function getArticleEditorRoute(alias, articleId, editorType) {
  let route = null;
  // if (editorType == 2) {
  //   route = {
  //     path: alias != "www" ? `/${alias}/illustrated-book` : `illustrated-book`,
  //     query: {
  //       id: articleId
  //     }
  //   };
  // } else if (editorType == 1 || editorType == 0) {
  //   route = {
  //     path: alias != "www" ? `/${alias}/editor` : `editor`,
  //     query: {
  //       id: articleId
  //     }
  //   };
  // }
  route = {
    path: alias != "www" ? `/${alias}/editor` : `editor`,
    query: {
      id: articleId
    }
  };
  return route;
}

/**
 * 获取游戏站点标识
 * @param {*} host
 * @returns
 */
export function getGameAlias(host) {
  host = host.split(".");
  let alias = host[0];
  return alias;
}

/**
 * 深拷贝
 * @param {*} obj
 * @param {*} clonedMap
 * @returns
 */
export function deepClone(obj, clonedMap = new WeakMap()) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  // 缓存避免循环引用
  if (clonedMap.has(obj)) {
    return clonedMap.get(obj);
  }

  // 正则表达式对象
  if (obj instanceof RegExp) {
    return new RegExp(obj);
  }

  // 日期对象
  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  let clone = Array.isArray(obj) ? [] : {};

  clonedMap.set(obj, clone);
  // 递归拷贝
  for (let key in obj) {
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      clone[key] = deepClone(obj[key], clonedMap);
    }
  }

  return clone;
}

/**
 * 检查是否移动端内容
 * @param {*} conetentJson
 * @returns
 */
export function checkIsImageTextContent(conetentJson = []) {
  let isImageText = true;
  for (const item of conetentJson) {
    if (item.type) {
      const typeList = ["paragraph", "image", "video"];

      if (!typeList.includes(item.type)) {
        isImageText = false;
        break;
      }

      if (item.children.length > 0) {
        isImageText = checkIsImageTextContent(item.children);
        if (!isImageText) break;
      }
    }
  }
  return isImageText;
}

/**
 * 验证身份证号码
 * @param { String } code 身份证号码
 */
export function identityIDCard(code) {
  // 身份证号前两位代表区域
  const city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外 "
  };
  const idCardReg = /^[1-9]\d{5}(19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i; // 身份证格式正则表达式
  let errorMessage = ""; // 错误提示信息
  let isPass = true; // 身份证验证是否通过（true通过、false未通过）

  // 如果身份证不满足格式正则表达式
  if (!code) {
    errorMessage = "请输入身份证号码";
    isPass = false;
  } else if (!code.match(idCardReg)) {
    errorMessage = "请输入正确的身份证号码";
    isPass = false;
  } else if (!city[code.substr(0, 2)]) {
    // 区域数组中不包含需验证的身份证前两位
    errorMessage = "请输入正确的身份证号码";
    isPass = false;
  } else if (code.length === 18) {
    // 18位身份证需要验证最后一位校验位
    code = code.split("");
    // ∑(ai×Wi)(mod 11)
    // 加权因子
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    // 校验位
    const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    let ai = 0;
    let wi = 0;
    for (let i = 0; i < 17; i++) {
      ai = parseInt(code[i]);
      wi = factor[i];
      sum += ai * wi; // 开始计算并相加
    }
    const last = parity[sum % 11]; // 求余
    if (last.toString() !== code[17]) {
      errorMessage = "请输入正确的身份证号码";
      isPass = false;
    }
  }
  return {
    errorMessage,
    isPass
  };
}

/**
 * 判断元素是否在可视范围内
 * @param {*} el
 * @returns
 */
export function isInViewPort(el, offset = 0) {
  const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  const top = el.getBoundingClientRect() && el.getBoundingClientRect().top;
  return top <= screenHeight + offset;
}

/**
 * 获取视频首帧图
 * @param {string} url
 * @returns {Promise<string>}
 */
export function getFirstFrame(url) {
  return new Promise(resolve => {
    let videoDom = document.createElement("video");
    videoDom.setAttribute("crossOrigin", "Anonymous");
    videoDom.autoplay = true;
    videoDom.muted = true;
    videoDom.onloadeddata = () => {
      let h = videoDom.videoHeight;
      let w = videoDom.videoWidth;

      if (w > 500) {
        h = (500 / w) * h;
        w = 500;
      }
      let canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      let ctx = canvas.getContext("2d");
      ctx.drawImage(videoDom, 0, 0, w, h);
      url = canvas.toDataURL("image/png");
      resolve(url);
    };
    videoDom.src = url;
  });
}

export function toast(text) {
  const div = document.createElement("div");
  div.classList.add("__temp_toast__");
  div.innerText = text;
  document.body.append(div);
  setTimeout(() => {
    div.remove();
  }, 1500);
}
/**
 * 检查是否已加载js
 * @param {*} url
 * @returns
 */
export function isScriptLoaded(url) {
  return Array.from(document.scripts).some(script => script.src.includes(url));
}
/**
 * 异步加载js
 * @param {*} url
 * @returns
 */
export function loadScript(url) {
  return new Promise((resolve, reject) => {
    if (isScriptLoaded(url)) {
      resolve();
      return;
    }
    // 创建 script 元素
    let script = document.createElement("script");
    script.type = "text/javascript"; // 设置类型为 JavaScript

    // 检查是否支持 onload 事件
    if (script.readyState) {
      // IE 浏览器
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null; // 清除事件
          resolve(); // 如果有回调函数，则执行
        }
      };
    } else {
      // 其他标准浏览器
      script.onload = function() {
        resolve(); // 加载完成后执行回调函数
      };
    }

    script.src = url; // 设置脚本的 URL
    document.head.appendChild(script); // 将 script 插入到 head 中
  });
}

/**
 * 检查css是否已加载
 * @param {、} url
 * @returns
 */
export function checkCSSLoaded(url) {
  return Array.from(document.styleSheets).some(sheet => sheet.href && sheet.href.includes(url));
}

/**
 * 异步加载css
 * @param {*} url
 * @returns
 */
export function loadCSS(url) {
  return new Promise((resolve, reject) => {
    // 判断是否已加载
    if (checkCSSLoaded(url)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = url;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
    document.head.appendChild(link);
  });
}

// 生成唯一key
export function createUniqueKey(length = 8) {
  return (
    Math.random()
      .toString()
      .substring(2)
      .substring(0, length) + Date.now().toString(36)
  );
}

// 生成唯一key, 字符串的
export function createUniqueStringKey(length = 8) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let key = "";
  for (let i = 0; i < length; i++) {
    key += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return key;
}

// 复制文本
export function copyText(text) {
  return new Promise((resolve, reject) => {
    let $div = document.createElement("div");
    $div.setAttribute("data-clipboard-text", text);
    $div.classList.add("page-share-copy-btn");
    document.body.appendChild($div);
    let clipboard = new Clipboard(".page-share-copy-btn");
    clipboard.on("success", e => {
      // 复制成功
      document.body.removeChild($div);
      clipboard.destroy();
      resolve();
    });
    clipboard.on("error", e => {
      // 不支持复制
      document.body.removeChild($div);
      clipboard.destroy();
      reject("浏览器不支持自动复制,请更换其他浏览器");
    });
    $div.click();
  });
}

/**
 * 写入内容到剪贴板
 * @param {*} data
 */
export const writeToClipboard = data => {
  const textarea = document.createElement("textarea");
  const handler = event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    for (const [key, value] of Object.entries(data)) {
      event.clipboardData && event.clipboardData.setData(key, value);
    }
  };
  textarea.addEventListener("copy", handler, true);
  textarea.style.position = "fixed";
  textarea.style.left = "-999999999px";
  textarea.style.top = "-999999999px";
  textarea.value = " ";
  // COMPAT: `safari`需要挂载在`DOM`上才能触发
  // `ipad`则需要挂载在内部`DOM`容器才能执行 暂不处理
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  textarea.removeEventListener("copy", handler);
  document.body.removeChild(textarea);
};

/**
 * 获取两数之间的随机数，包含两个参数
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function getRandomIntInclusive(min, max) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

/**
 * 数字千分位显示
 * @param {*} num
 * @returns
 */
export function formatNumberWithCommas(num) {
  // 处理整数部分
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 如果要处理小数部分，可以使用这个版本：
  // return num.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * 从Canvas中裁切指定区域
 * @param {HTMLCanvasElement} sourceCanvas - 原始Canvas元素
 * @param {number} fromTop - 从顶部开始裁切的像素距离
 * @param {number} height - 要裁切的高度
 * @returns {HTMLCanvasElement} 包含裁切内容的新Canvas元素
 */
export function cropCanvas(sourceCanvas, fromTop, height) {
  // 参数验证
  if (!(sourceCanvas instanceof HTMLCanvasElement)) {
    throw new Error("第一个参数必须是Canvas元素");
  }

  if (fromTop < 0 || height <= 0) {
    throw new Error("裁切位置和高度必须是正数");
  }

  if (fromTop + height > sourceCanvas.height) {
    throw new Error("裁切区域超出Canvas范围");
  }

  // 创建新的Canvas
  const croppedCanvas = document.createElement("canvas");
  croppedCanvas.width = sourceCanvas.width;
  croppedCanvas.height = height;

  // 获取上下文并执行裁切
  const ctx = croppedCanvas.getContext("2d");
  ctx.drawImage(
    sourceCanvas,
    0, // 源X坐标
    fromTop, // 源Y坐标
    sourceCanvas.width, // 源宽度
    height, // 源高度
    0, // 目标X坐标
    0, // 目标Y坐标
    sourceCanvas.width, // 目标宽度
    height // 目标高度
  );

  return croppedCanvas;
}

/**
 * 复制文本到剪贴板
 * @param {string} text - 要复制的文本
 * @returns {Promise<boolean>} 返回一个Promise，表示是否复制成功
 */
export function copyToClipboard(text) {
  return new Promise(resolve => {
    // 新方法: 使用navigator.clipboard API (现代浏览器支持)
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
      return;
    }

    // 旧方法: 创建textarea元素并选中文本 (兼容旧浏览器)
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 防止页面滚动
    textarea.style.opacity = "0"; // 透明不可见
    document.body.appendChild(textarea);
    textarea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        resolve(true);
      } else {
        resolve(false);
      }
    } catch (err) {
      resolve(false);
    } finally {
      document.body.removeChild(textarea);
    }
  });
}

/**
 * 数字转换为中文汉字小写（如：1 → 一，12 → 十二，123 → 一百二十三）
 * @param {*} num
 * @returns
 */
export function numberToChinese(num) {
  if (typeof num !== "number" || isNaN(num)) {
    return "非法数字";
  }

  // 处理负数
  if (num < 0) {
    return "负" + numberToChinese(-num);
  }

  // 处理小数部分
  if (num.toString().includes(".")) {
    const parts = num.toString().split(".");
    return (
      numberToChinese(parseInt(parts[0])) +
      "点" +
      parts[1]
        .split("")
        .map(n => {
          return ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"][parseInt(n)];
        })
        .join("")
    );
  }

  // 数字对应汉字
  const chineseNums = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  // 单位
  const units = ["", "十", "百", "千", "万", "十", "百", "千", "亿", "十", "百", "千", "兆"];

  // 0-9直接返回
  if (num >= 0 && num < 10) {
    return chineseNums[num];
  }

  // 10-19特殊处理（十一到十九）
  if (num >= 10 && num < 20) {
    return "十" + (num % 10 === 0 ? "" : chineseNums[num % 10]);
  }

  let result = "";
  let strNum = num.toString();
  let len = strNum.length;

  // 处理整数部分
  for (let i = 0; i < len; i++) {
    const digit = parseInt(strNum[i]);
    const unit = units[len - 1 - i];

    if (digit === 0) {
      // 处理连续的零
      if (result[result.length - 1] !== "零") {
        result += chineseNums[digit];
      }
      // 处理万、亿等单位前的零
      if (unit === "万" || unit === "亿" || unit === "兆") {
        result = result.replace(/零+$/, "") + unit;
      }
    } else {
      // 处理"一十"开头的情况，通常简化为"十"
      if (i === 0 && digit === 1 && unit === "十") {
        result += unit;
      } else {
        result += chineseNums[digit] + unit;
      }
    }
  }

  // 处理末尾的零
  result = result.replace(/零+$/, "");
  // 处理中间的多个零
  result = result.replace(/零+/g, "零");

  return result || "零";
}

export function getQueryParam(name, url = window.location.search) {
  const params = new URLSearchParams(url);
  return params.get(name);
}

/**
 * 根据live2d骨骼文件，判断需要加载的spine-player版本
 * @param {*} skelUrl
 * @param {*} jsonUrl
 * @returns
 */
export function getSpinePlayer(skelUrl, jsonUrl) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async function(resolve, reject) {
    // 判断是否有文件Url
    if (!skelUrl && !jsonUrl) reject("spine player加载错误：skelUrl or jsonUrl is null");
    // 获取包含版本号的字符串
    let str = "";
    if (skelUrl) {
      const response = await fetch(skelUrl);
      const blob = await response.blob();
      str = await blob.slice(0, 16).text();
    } else if (jsonUrl) {
      const response = await fetch(jsonUrl);
      const json = await response.json();
      str = json.skeleton.spine;
    }
    // 判断需要加载的spine版本
    if (/4\.0\.\d+/.test(str)) {
      // 加载css
      loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.css?t=10001`);
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.0.30.js?t=10001`).then(res => {
        setTimeout(() => {
          resolve(window.spine_4_0_30);
        }, 100);
      });
    } else if (/4\.1\.\d+/.test(str)) {
      // 加载css
      loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.css?t=10001`);
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.1.54.js?t=10001`).then(res => {
        setTimeout(() => {
          resolve(window.spine_4_1_54);
        }, 100);
      });
    } else if (/4\.2\.\d+/.test(str)) {
      // 加载css
      loadCSS(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.2.82.css?t=10001`);
      loadScript(`${process.env.VUE_APP_CDN_BASE}dist/static/spine-player-4.2.82.js?t=10001`).then(res => {
        setTimeout(() => {
          resolve(window.spine_4_2_82);
        }, 100);
      });
    } else {
      reject("spine player无法加载：not surport this version " + str);
    }
  });
}

export function v4() {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  /** 用来存储已经使用的字符，确保不重复 */
  const usedChars = new Set();
  while (result.length < 8) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    const char = characters[randomIndex];
    if (!usedChars.has(char)) {
      result += char;
      usedChars.add(char);
    }
  }
  return result;
}

/**
 * 改变rgba颜色值透明度
 * @param {*} rgbaString
 * @param {*} newAlpha
 * @returns
 */
export function changeRgbaAlpha(rgbaString = "", newAlpha) {
  return rgbaString.replace(
    /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/,
    (match, r, g, b, a) => `rgba(${r},${g},${b},${newAlpha})`
  );
}

/**
 * 埋点
 * @param pointName
 * @param options Object
 */
export function trackingPoint(pointName, options = {}) {
  if (window.staticFn) {
    window.staticFn.customEvent(pointName, options);
  }
}
